export default [

     {
          path: '/asset-group',
          name: 'AssetGroup',
          component: () => import("@/views/Page/AssetGroup/AssetGroup.vue"),
          meta: {
               title: 'Asset Group',
          },
     }
];